import { VisibilityOff } from "@mui/icons-material";
import { Switch } from "@mui/material";
import { ChangeEvent, ReactElement, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { IColumnDef } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

import { ColumnItem, ColumnItemText } from "./column.draggable.styled";

export const ColumnInactive = <T extends object>({
  item,
  onVisibilityChange,
}: {
  item: IColumnDef<T, unknown>;
  onVisibilityChange: (
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => void;
}): ReactElement => {
  const { t } = useTranslation();

  const translatedColumnTitle = useMemo(() => {
    return item.meta?.translationKey
      ? t(item.meta?.translationKey)
      : item.meta?.displayName || item.id;
  }, [item.id, item.meta?.displayName, item.meta?.translationKey, t]);

  return (
    <ColumnItem>
      <VisibilityOff sx={{ color: greyMui._400 }} />
      <ColumnItemText>{translatedColumnTitle}</ColumnItemText>

      <Switch
        className="col_switch"
        id={item.id as string}
        checked={false}
        disabled={item.meta?.orderable === false}
        onChange={onVisibilityChange}
      />
    </ColumnItem>
  );
};
